import Vue from "vue";

const nonExtinguishedVendors = [
  "Пост. 999в_остатки",
  "Пост. China_2",
  "Пост. склад",
  "Пост. склад2",
  "Пост. склад3",
  "Пост. 147",
];

const websocket = {
  namespaced: true,
  state: {
    item: {
      isConnected: false,
      isRegistered: false,
      message: "",
      reconnectError: false,
      closedCount: 0,
    },
  },
  mutations: {
    SOCKET_ONOPEN(state, event) {
      console.info("SOCKET_ONOPEN");

      Vue.prototype.$socket = event.currentTarget;
      state.item.isConnected = true;

      this.dispatch(
        "websocket/sendMessage",
        JSON.stringify({ apiKey: this.state.auth.item.apiKey })
      );
    },
    SOCKET_ONCLOSE(state, event) {
      console.info("SOCKET_ONCLOSE");

      if (state.item.closedCount > 100) {
        this.commit("auth/unsetAuth");
      }

      state.item.closedCount++;
      this.commit("messages/setMessage", {
        type: "error",
        code: "Ой все!",
        message: "Сокет был закрыт сервером",
      });
      state.item.isConnected = false;
    },
    SOCKET_ONERROR(state, event) {
      console.info("SOCKET_ONERROR");
      this.commit("messages/setMessage", {
        type: "error",
        code: "Ой все!",
        message: "Ошибка сокета",
      });
      console.error(state, event);
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE(state, message) {
      console.info("SOCKET_ONMESSAGE");
      if (this.state.auth.item.apiKey && message.data === ".") {
        this.dispatch("websocket/sendMessage", ".");
      } else {
        let messageData = null;

        try {
          messageData = JSON.parse(message.data.split(/\r?\n/)[0]);
        } catch (error) {
          console.error(error);
        }

        if (null === messageData) return;

        if (
          messageData.statusMessage === "ok" &&
          messageData.statusCode === 200
        ) {
          // PUR-8403
          // this.commit("messages/setMessage", {
          //   type: "success",
          //   code: "О да!",
          //   message: "Подключение к каналу обновлений установлено",
          // });

          state.item.isRegistered = true;
        } else {
          if (
            messageData.module === "popup" &&
            messageData.action === "popup"
          ) {
            this.commit("popup/setPopup", {
              type: messageData.payload.type,
              title: messageData.payload.title || "Системное сообщение",
              message: messageData.payload.message,
            });
          }

          if (
            messageData.module === "assembly_goals" &&
            messageData.action === "push_receptions"
          ) {
            this.commit("receptions/setItem", messageData.payload);
          }

          if (
            messageData.module === "assembly_goals" &&
            messageData.action === "refresh_reception"
          ) {
            if (messageData.payload.type === "product") {
              this.commit("receptions/updateProductItem", messageData.payload);
            }

            if (messageData.payload.type === "cell") {
              this.commit("receptions/setCell", messageData.payload.cell);
            }
          }

          if (
            messageData.module === "assembly_goals" &&
            messageData.action === "push_leftovers"
          ) {
            this.commit("leftovers/setItem", messageData.payload);
          }

          if (
            messageData.module === "assembly_goals" &&
            messageData.action === "refresh_leftover"
          ) {
            if (messageData.payload.type === "product") {
              this.commit("leftovers/updateProductItem", messageData.payload);
            }

            if (messageData.payload.type === "cell") {
              this.commit("leftovers/setCell", messageData.payload.cell);
            }
          }

          if (
            messageData.module === "assembly_goals" &&
            messageData.action === "notify_error"
          ) {
            this.commit("messages/setMessage", {
              type: "error",
              code: "Ох, 1С в гневе",
              message: '',
            });
          }

          if (
            messageData.module === "assembly_goals" &&
            messageData.action === "refresh_product"
          ) {
            let existsProduct = this.getters["orders/findProductForUpdate"](
              messageData.payload
            );

            if (!existsProduct) {
              this.commit("messages/setMessage", {
                type: "warning",
                code: "Ой вей!",
                // "Сервер пытается обновить товар, которого нет в интерфейсе сборки",
                message: "Ошибка",
              });
            } else {
              existsProduct.assembled = messageData.payload.assembled;

              // PUR-8403
              // if (existsProduct.quantity === messageData.payload.assembled) {
              //   this.commit("messages/setMessage", {
              //     type: "success",
              //     code: "О да!",
              //     message:
              //       "Товар " +
              //       existsProduct.article +
              //       " полносьтью укомплектован",
              //   });
              // } else {
              //   this.commit("messages/setMessage", {
              //     type: "info",
              //     code: "Ой ли!",
              //     message:
              //       "Товар " +
              //       existsProduct.article +
              //       " обновлен. Добавлено " +
              //       existsProduct.assembled +
              //       " из " +
              //       existsProduct.quantity +
              //       " единиц",
              //   });
              // }
            }
          }

          if (
            messageData.module === "assembly_goals" &&
            messageData.action === "push_products"
          ) {
            messageData.payload.orders.forEach((order) => {
              order.carts.forEach((cart) => {
                cart.products.forEach((product) => {
                  product.orderId = order.order_id;
                  product.orderNumber = order.order_number;
                  product.cartNumber = cart.number;
                  product.uniqueId = product.Item_ID;
                  product.hasReplacement = false;
                  product.replacemens = [];

                  if (!product.color) {
                    const colorMatches = product.description.match(
                      "(?<=цвет[-:\b])(.*?)$"
                    );

                    if (colorMatches && colorMatches.length) {
                      product.color = colorMatches[0].replace(".", "");
                    } else {
                      product.color = "";
                    }
                  }

                  let sort = product.sort;

                  if (
                    (typeof sort === "string" || sort instanceof String) &&
                    sort.includes("_")
                  ) {
                    const parts = sort.split("_");

                    let newSort = 0;

                    for (let index in parts) {
                      if (parseInt(index) === 0) {
                        newSort = newSort + parseInt(parts[index]) * 1000;
                      } else {
                        newSort = newSort + parseInt(parts[index]);
                      }
                    }

                    product.sort = isNaN(newSort) ? 0 : newSort;
                  } else if (
                    (typeof sort === "string" || sort instanceof String) &&
                    sort.charAt(0) === "0"
                  ) {
                    product.sort = parseInt(sort);
                  } else {
                    product.sort = parseInt(sort) + 100000;
                  }

                  if (
                    !product.additional_info ||
                    product.additional_info === " "
                  ) {
                    product.additional_info = "Неизвестно";
                  }

                  if (!product.reminder) {
                    product.reminder = null;
                  }

                  if (
                    nonExtinguishedVendors.includes(product.vendor) &&
                    product.quantity_on_storage === 0 &&
                    product.quantity_on_bunch === 0
                  ) {
                    product.reminder = "Предлагай замену";
                  }

                  product.images = {
                    small: [
                      "https://img.gepur.com/products/" +
                        Math.ceil(product.article / 5000) * 5000 +
                        `/` +
                        product.article +
                        "/simple/388/" +
                        product.article +
                        "_1.jpg",
                      "https://img.gepur.com/products/" +
                        Math.ceil(product.article / 5000) * 5000 +
                        `/` +
                        product.article +
                        "/simple/388/" +
                        product.article +
                        "_2.jpg",
                      "https://img.gepur.com/products/" +
                        Math.ceil(product.article / 5000) * 5000 +
                        `/` +
                        product.article +
                        "/simple/388/" +
                        product.article +
                        "_3.jpg",
                    ],
                    big: [
                      "https://img.gepur.com/products/" +
                        Math.ceil(product.article / 5000) * 5000 +
                        `/` +
                        product.article +
                        "/simple/origins/" +
                        product.article +
                        "_1.jpg",
                      "https://img.gepur.com/products/" +
                        Math.ceil(product.article / 5000) * 5000 +
                        `/` +
                        product.article +
                        "/simple/origins/" +
                        product.article +
                        "_2.jpg",
                      "https://img.gepur.com/products/" +
                        Math.ceil(product.article / 5000) * 5000 +
                        `/` +
                        product.article +
                        "/simple/origins/" +
                        product.article +
                        "_3.jpg",
                    ],
                  };

                  product.quantity_on_bunch = product.quantity_on_bunch || 0;

                  product.form = {
                    orderNumber: order.order_number,
                    cartNumber: cart.number,
                    article: product.article,
                    size: product.size,
                    comment: null,
                    assembled: product.assembled,
                  };
                });

                cart.products.sort((a, b) => a.sort - b.sort);
              });
            });

            this.commit("orders/setOrders", messageData.payload.orders);
            this.commit("product/unsetProduct");
            this.commit("tab/setTab", "all");

            // PUR-8403
            // this.commit("messages/setMessage", {
            //   type: "info",
            //   code: "Ой ли!",
            //   message: "Выгружен новый список товаров для сборки",
            // });

            this.dispatch("orders/findJoinedTasks", messageData.payload.orders);
          }
        }
      }
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT(state, count) {
      console.info("SOCKET_RECONNECT", count, state.item.closedCount);
    },
    SOCKET_RECONNECT_ERROR(state) {
      console.info("SOCKET_RECONNECT_ERROR");
      state.item.reconnectError = true;
      this.commit("messages/setMessage", {
        type: "error",
        code: "Ой все!",
        message: "Ошибка переподключения к сокету",
      });
    },
  },
  actions: {
    sendMessage: function (context, message) {
      Vue.prototype.$socket.send(message);
    },
  },
  getters: {},
};

export default websocket;
